/**
 * Lugg — Notify Me
 * Handles: modal open/close, variant tracking, form submit → Worker /lugg/oos/subscribe
 * No dependencies. Deferred. ~3 KB.
 */
(function () {
  'use strict';

  var cfg = window.__lugg_nm || {};
  var BASE = (cfg.baseUrl || 'https://keplin-mcp.mo-3e5.workers.dev').replace(/\/$/, '');
  var AUTH = cfg.auth || '';

  // ── DOM refs ──────────────────────────────────────────────────────────────
  var overlay  = document.getElementById('nm-overlay');
  var closeBtn = document.getElementById('nm-close');
  var form     = document.getElementById('nm-form');
  var emailEl  = document.getElementById('nm-email');
  var submitEl = document.getElementById('nm-submit');
  var errEl    = document.getElementById('nm-err');
  var okEl     = document.getElementById('nm-ok');
  var okMsg    = document.getElementById('nm-ok-msg');
  var labelEl  = document.getElementById('nm-product-label');

  var activeBtn = null;

  // ── Open / close ─────────────────────────────────────────────────────────

  function open(btn) {
    if (!overlay) return;
    activeBtn = btn;

    var productTitle = btn.dataset.nmProductTitle || '';
    var variantTitle = btn.dataset.nmVariantTitle || '';
    if (labelEl) {
      labelEl.textContent = variantTitle
        ? productTitle + ' — ' + variantTitle
        : productTitle;
    }

    if (emailEl && cfg.customerEmail) {
      emailEl.value = cfg.customerEmail;
    }

    resetState();
    overlay.classList.add('is-open');
    document.body.classList.add('nm-open');
    overlay.removeAttribute('aria-hidden');
    if (emailEl) {
      setTimeout(function () { emailEl.focus(); }, 40);
    }
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.classList.remove('nm-open');
    overlay.setAttribute('aria-hidden', 'true');
    activeBtn = null;
  }

  function resetState() {
    if (form)     form.style.display   = '';
    if (okEl)     okEl.style.display   = 'none';
    if (errEl)    errEl.textContent    = '';
    if (submitEl) { submitEl.disabled  = false; submitEl.textContent = 'Notify Me'; }
    if (emailEl && !cfg.customerEmail)  emailEl.value = '';
  }

  // ── Submit ────────────────────────────────────────────────────────────────

  function handleSubmit(e) {
    e.preventDefault();
    if (!activeBtn) return;

    var email = (emailEl && emailEl.value.trim()) || '';
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (errEl) errEl.textContent = 'Please enter a valid email address.';
      return;
    }

    if (errEl)    errEl.textContent   = '';
    if (submitEl) { submitEl.disabled = true; submitEl.textContent = 'Sending…'; }

    var productTitle  = activeBtn.dataset.nmProductTitle || '';
    // For single-variant products "Default Title" is cleared to '' — fall back
    // to the product title so the Worker's required variant_title is satisfied.
    var variantTitle  = activeBtn.dataset.nmVariantTitle || productTitle;

    var payload = {
      email:          email,
      variant_id:     activeBtn.dataset.nmVariantId    || '',
      product_id:     activeBtn.dataset.nmProductId    || '',
      product_title:  productTitle,
      variant_title:  variantTitle,
      product_handle: activeBtn.dataset.nmProductHandle || '',
      product_url:    activeBtn.dataset.nmProductUrl   || ''
    };

    // Attach customer_id when logged in (numeric ID from Liquid config)
    if (cfg.customerId) {
      payload.customer_id = cfg.customerId;
    }

    fetch(BASE + '/lugg/oos/subscribe', {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-MCP-Auth':   AUTH
      },
      body:    JSON.stringify(payload)
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
      .then(function (r) {
        if (r.ok && (r.data.status === 'subscribed' || r.data.status === 'already_subscribed')) {
          if (form)   form.style.display = 'none';
          var msg = r.data.status === 'already_subscribed'
            ? "You're already on the list for this item."
            : "You're on the list! We'll email you when it's back.";
          if (okMsg)  okMsg.textContent  = msg;
          if (okEl)   okEl.style.display = 'flex';
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event:               'notify_me_signup',
            product_title:       productTitle,
            product_id:          payload.product_id,
            variant_id:          payload.variant_id,
            product_handle:      payload.product_handle,
            subscription_status: r.data.status
          });
          setTimeout(close, 3200);
        } else {
          if (errEl)    errEl.textContent   = (r.data && r.data.error) || 'Something went wrong. Please try again.';
          if (submitEl) { submitEl.disabled = false; submitEl.textContent = 'Notify Me'; }
        }
      })
      .catch(function () {
        if (errEl)    errEl.textContent   = 'Network error. Please try again.';
        if (submitEl) { submitEl.disabled = false; submitEl.textContent = 'Notify Me'; }
      });
  }

  // ── Variant tracking (product page only) ──────────────────────────────────

  function updateProductBtn(variant) {
    var notifyBtn = document.querySelector('[data-nm-page="product"]');
    var addBtn = document.querySelector('form[action="/cart/add"] button[type="submit"][name="add"]');

    var available = variant.available;

    if (notifyBtn) {
      notifyBtn.style.display = available ? 'none' : 'block';
      if (!available) {
        notifyBtn.dataset.nmVariantId    = variant.id;
        var vTitle = (variant.title === 'Default Title') ? '' : (variant.title || '');
        notifyBtn.dataset.nmVariantTitle = vTitle;
      }
    }

    if (addBtn) {
      addBtn.style.display = available ? '' : 'none';
    }
  }

  function watchVariants() {
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && (e.detail.variant || e.detail);
      if (v && v.id) updateProductBtn(v);
    });

    var input = document.querySelector(
      'form[action="/cart/add"] input[name="id"], [data-product-form] input[name="id"]'
    );
    if (!input) return;

    var observer = new MutationObserver(function () {
      var id = input.value;
      if (!id) return;
      fetch('/variants/' + id + '.js')
        .then(function (r) { return r.json(); })
        .then(updateProductBtn)
        .catch(function () {});
    });

    observer.observe(input, { attributes: true, attributeFilter: ['value'] });
  }

  // ── Wire up events ─────────────────────────────────────────────────────────

  function init() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.nm-btn');
      if (btn) open(btn);
    });

    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (form)     form.addEventListener('submit', handleSubmit);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    if (document.querySelector('[data-nm-page="product"]')) {
      watchVariants();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
